import React, { useEffect, useState, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Pagination from "../../Reusablecomponents/Pagination";
import ExportButton from "../../Reusablecomponents/ExportButton";
import { FaEdit, FaTrash, FaPlus, FaFileExport, FaUpload, FaEye } from "react-icons/fa";
import "../../css/others/Table.css";
import { apiCall } from "../../main/ApiCall";
import ToastPopup from "../../popups/ToastPopup";
import axios from "axios";
import * as XLSX from 'xlsx-js-style';
import FunctionEditChecklist from "../../popups/FunctionEditChecklist";
import FunctionAddChecklist from "../../popups/FunctionAddChecklist";
import EncryptionUtils from "../../main/encryptionUtils";
import { createToastMessage, ToastMessage } from "../../interFaces/interfaces";
const FunctionChecklist: React.FC = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false);
  const [editableDetails, setEditableDetails] = useState<any>(null);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState<boolean>(false);
  const [newChecklistName, setNewChecklistName] = useState<string>("");
  const [newChecklistDescription, setNewChecklistDescription] = useState<string>("");
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const [deleteFunctionTemplateId, setDeleteFunctionTemplateId] = useState<string | null>(null);
  const [fields, setFields] = useState<any>({});
  const [file, setFile] = useState<File | null>(null);
  const [selectedChecklists, setSelectedChecklists] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<'DRAFT' | 'ACTIVE'>('DRAFT');
  const email = localStorage.getItem("email") || "";
  const clientId = localStorage.getItem("clientId");
  const fileInputRef = useRef<HTMLInputElement>(null);
  const columns = [{ key: "checkbox", label: <input type="checkbox" checked={selectAll} onChange={(e) => handleSelectAll(e.target.checked)} /> }, { key: "serialNumber", label: "S.No." }, { key: "functionCheckListName", label: "Function CheckList Name" }, { key: "functionDescription", label: "Function Description" }, { key: "actions", label: "Action" }];
  const column = [{ key: "functionCheckListName", label: "Function CheckList Name" }, { key: "functionDescription", label: "Function Description" }];
  useEffect(() => {
    const permissions = EncryptionUtils.get<any>("permissions", null);
    if (permissions.tabs && permissions.tabs["functionCheckListManagement"]) {
      setFields(permissions.tabs["functionCheckListManagement"].fields);
    }
  }, []);
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await apiCall("get", "/api/function-template", null, { clientId, page: currentPage - 1, size: itemsPerPage, status: activeTab });
      setData(response?.content || []);
      setTotalElements(response?.totalElements || 0);
      setTotalPages(response?.totalPages || 0);
      setSelectedChecklists([]);
      setSelectAll(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalElements(0);
      setTotalPages(0);
    } finally {
      setLoading(false);
    }
  }, [clientId, currentPage, itemsPerPage, activeTab]);
  const fetchAllDataForExport = useCallback(async () => {
    try {
      const response = await apiCall("get", "/api/function-template", null, { clientId, page: 0, size: totalElements, status: activeTab });
      return response.content || [];
    } catch (error) {
      console.error("Error exporting data:", error);
      return [];
    }
  }, [clientId, totalElements, activeTab]);
  const handleSelectChecklist = (id: string, isChecked: boolean) => {
    if (isChecked) {
      setSelectedChecklists((prev) => [...prev, id]);
    } else {
      setSelectedChecklists((prev) => prev.filter((item) => item !== id));
      setSelectAll(false);
    }
  };
  const handleSelectAll = (isChecked: boolean) => {
    setSelectAll(isChecked);
    if (isChecked) {
      const allIds = data.map((item) => item.functionTemplateId);
      setSelectedChecklists(allIds);
    } else {
      setSelectedChecklists([]);
    }
  };
  const getFunctionChecklistsWithoutQuestions = async () => {
    const noQuestionNames: string[] = [];
    for (const row of data) {
      if (selectedChecklists.includes(row.functionTemplateId)) {
        try {
          const response = await apiCall("get", `/api/function-template/${row.functionTemplateId}/questions/edit`, null, { page: currentPage - 1, size: itemsPerPage });
          const hasQuestions = response.content && response.content.length > 0;
          if (!hasQuestions) {
            noQuestionNames.push(row.functionCheckListName);
          }
        } catch {
          noQuestionNames.push(row.functionCheckListName);
        }
      }
    }
    return noQuestionNames;
  };
  const handlePublishSelected = async () => {
    if (selectedChecklists.length === 0) {
      setMessage(createToastMessage("No checklists selected.", "warning", 3000));
      return;
    }
    const noQuestionChecklists = await getFunctionChecklistsWithoutQuestions();
    if (noQuestionChecklists.length > 0) {
      setMessage(createToastMessage(`Please add questions for: ${noQuestionChecklists.join(", ")}`, "warning", 3000));
      return;
    }
    try {
      setLoading(true);
      for (const functionTemplateId of selectedChecklists) {
        await apiCall("post", `/api/function-template/${functionTemplateId}/publish`);
      }
      setMessage(createToastMessage("Checklists published successfully.", "success", 3000));
      fetchData();
    } catch (error: any) {
      const msg = error?.response?.data?.message || "Failed to publish selected checklists.";
      setMessage(createToastMessage(msg, "error", 3000));
    } finally {
      setLoading(false);
    }
  };
  const handleExportChecklist = async (functionTemplateId: string, functionCheckListName: string) => {
    try {
      const response = await apiCall("get", `/api/function-template/${functionTemplateId}/questions/edit`, null, { page: 0, size: 2_147_483_647 });
      const questions = response.content || [];
      if (questions.length === 0) {
        setMessage(createToastMessage("No questions available to export.", "warning", 3000));
        return;
      }
      const headerMap: Record<string, string> = { functionAreaName: "Audit Area", questionText: "Audit Question", evidenceRequired: "Required Evidence", isoClauseReference: "ISO Clause", annexAControlReference: "Annex A Control Mapping" };
      const selectedFields = Object.keys(headerMap);
      const dataWithCustomHeaders = questions.map((q: any) => {
        const row: Record<string, any> = {};
        selectedFields.forEach((field) => {
          row[headerMap[field]] = q[field] ?? "";
        });
        return row;
      });
      const worksheet = XLSX.utils.json_to_sheet(dataWithCustomHeaders);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Function_Checklist");
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${functionCheckListName}_Questions.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || "Failed to export checklist";
      setMessage(createToastMessage(errorMessage, "error", 3000));
    }
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
  };
  const handleBulkUpload = async () => {
    if (!file) {
      setMessage(createToastMessage("Please choose a file before uploading.", "error", 3000));
      return;
    }
    if (!clientId) {
      setMessage(createToastMessage("Client ID not found.", "error", 3000));
      return;
    }
    try {
      setLoading(true);
      const presignedUrlResponse = await apiCall("get", `/api/bulk-upload/s3presigneduploadurl?fileName=${file.name}&action=function_checklist_creation`);
      const presignedUrl = presignedUrlResponse;
      if (!presignedUrl) {
        throw new Error("Failed to retrieve presigned upload URL.");
      }
      await axios.put(presignedUrl, file, { headers: { "Content-Type": file.type } });
      const urlObj = new URL(presignedUrl);
      const fileKey = decodeURIComponent(urlObj.pathname.substring(1));
      await apiCall("post", "/api/bulk-upload/complete", { clientId, fileKey });
      await apiCall("get", "/api/bulk-upload/process-messages");
      setMessage(createToastMessage("File processed successfully!", "success", 3000));
      setFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setTimeout(() => window.location.reload(), 3000);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || "Error during bulk upload";
      setMessage(createToastMessage(errorMessage, "error", 3000));
    } finally {
      setLoading(false);
      setFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };
  useEffect(() => { fetchData() }, [fetchData]);
  const handleDelete = (functionTemplateId: string) => {
    setDeleteFunctionTemplateId(functionTemplateId);
    setIsDeleteModalOpen(true);
  };
  const handleEditClick = (row: any) => {
    setEditableDetails({ functionTemplateId: row.functionTemplateId, functionCheckListName: row.functionCheckListName, description: row.functionDescription });
    setIsEditModalOpen(true);
  };
  const handleSaveChanges = async () => {
    if (!editableDetails) return;
    try {
      setLoading(true);
      await apiCall("put", `/api/function-template/${editableDetails.functionTemplateId}`, { functionCheckListName: editableDetails.functionCheckListName, functionDescription: editableDetails.description, modifiedBy: email });
      setMessage(createToastMessage("Checklist updated successfully!", "success", 2500));
      setIsEditModalOpen(false);
      fetchData();
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || "Failed to update checklist";
      setMessage(createToastMessage(errorMessage, "error", 3000));
    } finally {
      setLoading(false);
    }
  };
  const handleSaveNewChecklist = async () => {
    const newChecklist = { functionCheckListName: newChecklistName, functionDescription: newChecklistDescription, createdBy: email, clientId: clientId };
    try {
      setLoading(true);
      await apiCall("post", "/api/function-template", newChecklist);
      setMessage(createToastMessage("Checklist created successfully!", "success", 2500));
      setIsCreateModalOpen(false);
      setNewChecklistName("");
      setNewChecklistDescription("");
      fetchData();
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || "Failed to create checklist";
      setMessage(createToastMessage(errorMessage, "error", 3000));
    } finally {
      setLoading(false);
    }
  };
  const handleOpenCreateModal = () => {
    setIsCreateModalOpen(true);
  };
  const handleDeleteChecklist = async () => {
    if (!deleteFunctionTemplateId) return;
    try {
      setLoading(true);
      await apiCall("delete", `/api/function-template/${deleteFunctionTemplateId}`);
      setMessage(createToastMessage("Checklist deleted successfully!", "success", 3000));
      fetchData();
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || "Failed to delete checklist";
      setMessage(createToastMessage(errorMessage, "error", 3000));
    } finally {
      setLoading(false);
      setIsDeleteModalOpen(false);
      setDeleteFunctionTemplateId(null);
    }
  };
  const handleDownloadTemplate = async () => {
    try {
      setLoading(true);
      const response = await apiCall("get", "/api/bulk-upload/s3presigneddownloadurl", null, { fileName: "function_checklist_template.xlsx", action: "default" });
      const presignedUrl = response;
      if (!presignedUrl) {
        throw new Error("Failed to retrieve download URL");
      }
      const fileResponse = await axios.get(presignedUrl, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([fileResponse.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "function_checklist_template.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setMessage(createToastMessage("Template downloaded successfully.", "success", 3000));
    } catch (error) {
      setMessage(createToastMessage("Failed to download template.", "error", 3000));
    } finally {
      setLoading(false);
    }
  };
  const handleNavigateToGlobalFunctionTemplates = () => {
    navigate("/globalfunctiontemplate");
  };
  const handleViewFunctionChecklist = (row: any) => {
    navigate(`/functionviewchecklistdetails/${row.functionTemplateId}`);
  };
  const handleAddFunctionQuestions = (row: any) => {
    navigate(`/functionchecklistdetails/${row.functionTemplateId}`, {
      state: { status: activeTab },
    });
  };
  const triggerFileInput = () => { fileInputRef.current?.click() };
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Function Checklists</h2>
        <div className="table-title-actions">
          {fields.create && (
            <button className="create-checklist" onClick={handleOpenCreateModal}>Create Function Checklist</button>
          )}
          {fields.view && (
            <button onClick={handleDownloadTemplate} className="checklist-download-button">Download Function Checklist Template</button>
          )}
            {fields.upload && (
              <button type="button" className={`upload-checklist ${file ? "disabled" : ""}`} onClick={triggerFileInput} disabled={!!file}>Upload Function Checklist</button>
            )}
            <input ref={fileInputRef} type="file" accept=".csv, .xlsx, .json" onChange={handleFileChange} className="hidden-input" data-testid="upload-checklist-input" disabled={!!file} />
          {file && (
            <button onClick={handleBulkUpload} className="checklist-upload-button"><FaUpload />Upload File</button>
          )}
          {fields.view && (
            <button className="globaltemplates" onClick={handleNavigateToGlobalFunctionTemplates}>Global Function Checklists</button>
          )}
          {activeTab === 'DRAFT' && (
            <button className="publish-selected" onClick={handlePublishSelected}>Publish</button>
          )}
          <ExportButton data={data} columns={column} fetchAllData={fetchAllDataForExport} fileName={`Function_CheckLists_${activeTab}`} />
        </div>
      </div>
      <div className="tabs-container">
        <button className={`tab-button ${activeTab === 'DRAFT' ? 'active' : ''}`} onClick={() => setActiveTab('DRAFT')}> Draft Checklists</button>
        <button className={`tab-button ${activeTab === 'ACTIVE' ? 'active' : ''}`} onClick={() => setActiveTab('ACTIVE')}> Active Checklists</button>
      </div>
      <div className="table-container">
        <div className="table-inner-container">
          <table className="main-table">
            <thead>
              <tr>
                {activeTab === 'DRAFT' && <th key="checkbox">{columns[0].label}</th>}
                <th key="serialNumber">{columns[1].label}</th>
                <th key="functionCheckListName">{columns[2].label}</th>
                <th key="functionDescription">{columns[3].label}</th>
                <th key="actions">{columns[4].label}</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={activeTab === 'DRAFT' ? 5 : 4} className="no-data">Loading...</td>
                </tr>
              ) : data.length === 0 ? (
                <tr>
                  <td colSpan={activeTab === 'DRAFT' ? 5 : 4} className="no-data">No data available</td>
                </tr>
              ) : (
                data.map((row, index) => (
                  <tr key={row.functionTemplateId}>
                    {activeTab === 'DRAFT' && (
                      <td>
                        <input type="checkbox" checked={selectedChecklists.includes(row.functionTemplateId)} onChange={(e) => handleSelectChecklist(row.functionTemplateId, e.target.checked)} />
                      </td>
                    )}
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{row.functionCheckListName || "Empty"}</td>
                    <td>{row.functionDescription || "Empty"}</td>
                    <td>
                      {activeTab === 'ACTIVE' && fields.view && (<FaEye className="action-button" onClick={() => handleViewFunctionChecklist(row)} title="View Questions" />)}
                      {fields.create && (
                        <FaPlus className="action-button" onClick={() => handleAddFunctionQuestions(row)} title="Add Questions" />
                      )}
                      {activeTab === 'DRAFT' && fields.edit && (
                        <FaEdit className="action-button" onClick={() => handleEditClick(row)} title="Edit Function CheckList" />
                      )}
                      {activeTab === 'DRAFT' && fields.delete && (
                        <FaTrash className="action-button" onClick={() => handleDelete(row.functionTemplateId)} title="Delete Function CheckList" />
                      )}
                      <FaFileExport className="action-button" onClick={() => handleExportChecklist(row.functionTemplateId, row.functionCheckListName)} title="Download File" />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
      {isEditModalOpen && (
        <FunctionEditChecklist editableDetails={editableDetails} setEditableDetails={setEditableDetails} handleSaveChanges={handleSaveChanges} onClose={() => setIsEditModalOpen(false)} />
      )}
      {isCreateModalOpen && (
        <FunctionAddChecklist newChecklistName={newChecklistName} newChecklistDescription={newChecklistDescription} setNewChecklistName={setNewChecklistName} setNewChecklistDescription={setNewChecklistDescription} handleSaveNewChecklist={handleSaveNewChecklist} onClose={() => setIsCreateModalOpen(false)} />
      )}
      {isDeleteModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Are you sure you want to delete this checklist?</h3>
            <div className="buttons">
              <button className="cancelbutton" onClick={() => setIsDeleteModalOpen(false)}>Cancel</button>
              <button className="deletebutton" onClick={handleDeleteChecklist}>Yes, Delete</button>
            </div>
          </div>
        </div>
      )}
      {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
    </div>
  );
};
export default FunctionChecklist;